var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-batch-monitoring',{staticClass:"pt-batch-monitoring__withData",attrs:{"data":_vm.batchMessage,"loading":_vm.loading},on:{"getCurrentBatch":_vm.getCurrentBatch,"getExceptionExport":_vm.getExceptionExport}})}
var staticRenderFns = []

export { render, staticRenderFns }